module.exports = __webpack_public_path__ + "a88c8944307661d6b49a102e4656e2e0.png";